<template>
  <AppSidebar
    :visible="showNavigationSidebar"
    :dismiss-on-body-click="false"
    :has-close-button="false"
    class="insights-navigation"
    :class="`${currentDashboard}-dashboard`"
    :sidebar-style="sidebarStyle"
    @show="toggleNavigationSidebar"
    @close="toggleNavigationSidebar"
  >
    <InsightsNavigationLists />
  </AppSidebar>
</template>

<script>
import AppSidebar from '~/components/AppSidebar.vue';
import InsightsNavigationLists from '~/components/insights/InsightsNavigationLists.vue';
import { mapGetters, mapActions } from 'vuex';
import { debounce } from 'lodash-es';

export default {
  name: 'InsightsNavigation',
  components: {
    AppSidebar,
    InsightsNavigationLists,
  },
  data() {
    return {
      // arbitrary padding close to the correct
      sidebarStyle: 'padding-top: 140px',
    };
  },
  computed: {
    ...mapGetters(['showNavigationSidebar', 'currentDashboard']),
  },
  mounted() {
    this.debouncedHandleScroll = debounce(this.handleScroll);
    window.addEventListener('scroll', this.debouncedHandleScroll);
    this.sticky = document.getElementById('insights-sticky-header');
    this.resizeObserver = new ResizeObserver(this.debouncedHandleScroll);
    this.resizeObserver.observe(this.sticky);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.debouncedHandleScroll);
    this.resizeObserver.unobserve(this.sticky);
  },
  methods: {
    ...mapActions(['toggleNavigationSidebar']),
    handleScroll() {
      const stickyBottom = document.getElementById('insights-sticky-header')?.getBoundingClientRect()?.bottom;

      if (!stickyBottom) {
        return;
      }
      const sidebarStyle = `padding-top: ${Math.round(stickyBottom)}px`;

      if (this.sidebarStyle !== sidebarStyle) {
        this.sidebarStyle = sidebarStyle;
      }
    },
  },
};
</script>
